module.exports = (__parcel__import__("2IazR")).then(() => parcelRequire('4MKVl'));